module.exports = __webpack_public_path__ + "static/media/aibory-logo-3@2x.f3d002ab.png";